import React, { useState, useMemo, useRef, useContext } from "react";
import { useDropzone } from "react-dropzone";
import "./dropzone.css";
// import captureVideoFrame from "capture-video-frame";
import bgImage from "./assets/dropzoneBGImage.png";
import DATA_PRODUCTS from "./DATA_PRODUCTS";
import OpacityContext from "./OpacityContext";

// const baseStyle = {
//   outline: "#f5f5f5 dashed 2px"
// };

const acceptStyle = {
  boxShadow: "0px 0px 8px 1px #00e676"
};

const rejectStyle = {
  boxShadow: "0px 0px 8px 1px #ff1744"
};
const dzBackgroundImage = {
  width: "100%",
  height: "100%",
  backgroundImage: `url(${bgImage})`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  position: "absolute",
  zIndex: "100"
};

export default function DropzoneFSA_LFD(props) {
  //* removed: setLfdFile,
  const {
    productIndex,
    shakeDropzoneBGImage,
    lfdFile,
    pfdFile,
    setPfdFile
  } = useContext(OpacityContext);

  //* assigned but never used, comment out for now
  /*const handleContinueButtonDisabled = bool => {
    props.handleContinueButtonDisabled(bool);
  };*/

  const acceptedFileTypeString = props.acceptedFileTypeString;
  const acceptedFileTypeMessageString = getHintString(acceptedFileTypeString);
  const droppedFileType = props.droppedFileType;

  const handleWarningMessageText = props.handleWarningMessageText;

  const [mediaType, setMediaType] = useState("image");

  const ref = useRef(null);

  // Only update lfdFile, never pfdFile
  const handleDropzoneChanges = (name, value) => {
    // this is special for VSA.  Same file always used for both so populate both
    // dropped file type = elevator, landscape, portrait, standard, svg.
    // this writes the name/value pair to the approprate dropped file in app.js

    console.log(
      `DropzoneFSA_LFD.js LFD asset updating handleDropzoneChanges(), what is name(${name}) and value(${value})`
    );

    if (props.handleDropzoneChanges) {
      props.handleDropzoneChanges(name, value, "landscape");
      console.log(`DropzoneFSA_LFD.js props.handleDropzoneChanges for LFD`);
      // props.handleDropzoneChanges(name, value, "portrait"); //this causes an update on both, which is helpful for VSA, but that's a discontinued product atm
    }

    // If the payload for LFD is being set, update PFD to match

    console.log(`DropzoneFSA_LFD.js setting PFD file to match LFD payload`);
    if (!pfdFile.payload) {
      let newValueForPFD = value;
      if (name === "name") {
        console.log(
          `DropzoneFSA_LFD.js we want to setPfdFile name to be pfd instead of lfd to avoid a d101 key value pair being identical between LFD and PFD.`
        );
        newValueForPFD = value.replace(/lfd/g, "pfd");
      }
      console.log(`DropzoneFSA_LFD.js setPfdFile to ${newValueForPFD}`); // this will be the same as ${value} in all cases except the name
      setPfdFile(prevState => ({
        ...prevState,
        [name]: newValueForPFD
      }));

      if (props.handleDropzoneChanges) {
        props.handleDropzoneChanges(name, newValueForPFD, "portrait"); //* refresh the portrait state in an attempt to load the asset
        console.log(`DropzoneFSA_LFD.js props.handleDropzoneChanges`);
      }
    } else {
      console.log(
        `DropzoneFSA_LFD.js ... but PFD has a payload set already, do not overwrite it.`
      );
    }
  };

  const handleDropzoneChangesJustLFD = (name, value) => {
    // this is special for VSA.  Same file always used for both so populate both
    // dropped file type = elevator, landscape, portrait, standard, svg.
    // this writes the name/value pair to the approprate dropped file in app.js

    props.handleDropzoneChanges(name, value, "landscape");
  };

  function getHintString(str) {
    let newString = str.split(",");
    let stringArrayMap = newString.map(function(value) {
      let split = value.split("/");
      return split[1];
    });
    return "accepted files: " + stringArrayMap.join(", ");
  }

  //////////////////////////////

  const [showHint, setShowHint] = useState(false);

  // this is where dropped files are added (local preview)
  const [files, setFiles] = useState([]);

  // --- External file preview support (NEW) ------------------------------------------
  // If lfdFile.payload exists, use it for preview
  const externalFile = lfdFile && lfdFile.payload ? lfdFile.payload : null;
  // Combine local files and externalFile for preview
  const previewFiles = externalFile
    ? [
        Object.assign({}, externalFile, {
          preview: externalFile.preview || URL.createObjectURL(externalFile),
          __previewKey: externalFile.name + "-" + externalFile.lastModified
        })
      ]
    : files.map(file =>
        Object.assign({}, file, {
          __previewKey: file.name + "-" + file.lastModified
        })
      );

  // Unified preview rendering (NEW)
  const imagePreview = previewFiles.map(file => (
    <img
      key={file.__previewKey}
      src={file.preview}
      style={{ width: "100%" }}
      alt="preview"
    />
  ));
  const videoPreview = previewFiles.map(file => (
    <video key={file.__previewKey} loop style={{ width: "100%" }}>
      <source src={file.preview} />
    </video>
  ));
  // ---------------------------------------------------------------------------------

  // Removed imperative DOM manipulation for preview. Preview is now handled by React rendering only.
  // If you need to handle video frame capture, keep that logic in a separate effect, but do not manipulate the DOM for preview.

  //   useEffect(() => {
  //   // you wan this to run after drop and when lfd and pfd file state has been set
  //   // just running after drop will not work because state will not be set yet
  //   // this keeps it from running on first render

  //   // at this point a file has been dropped in LFD and
  //   // both PFD and LFD files have been written to
  //   if (Object.keys(lfdFile).length > 0 && lfdFile.payload !== null) {
  //     handleContinueButtonDisabled(true);
  //     const el = ref.current;

  //     // if this is a video, create a video tag
  //     if (mediaType === "video") {
  //       const elemV = document.createElement("video");
  //       elemV.style = "position: absolute; z-index: 1;";
  //       elemV.id = "videoToCapture";
  //       elemV.autoplay = true;
  //       elemV.loop = true;
  //       elemV.src = URL.createObjectURL(lfdFile.payload);

  //       const mutationObserver = new MutationObserver((entries) => {
  //         elemV.addEventListener("canplay", () => {
  //           const capturedFrame = captureVideoFrame(elemV, "png");
  //           handleDropzoneChangesJustLFD("videoCapture", capturedFrame);
  //           mutationObserver.disconnect();
  //         });
  //       });
  //       mutationObserver.observe(el, { childList: true });

  //       el.appendChild(elemV);
  //     } else {
  //       const elemI = document.createElement("img");
  //       elemI.style = "position: absolute; left: 0px; z-index: 10;";
  //       elemI.setAttribute("src", URL.createObjectURL(lfdFile.payload));
  //       const el = ref.current;
  //       while (el.firstChild) {
  //         el.removeChild(el.lastChild);
  //       }
  //       setTimeout(() => {
  //         handleContinueButtonDisabled(false);
  //         el.appendChild(elemI);
  //       }, 100);
  //     }
  //   }
  // }, [lfdFile.payload]);

  // useEffect(() => {
  //   if (Object.keys(lfdFile).length > 0 && lfdFile.payload !== null) {
  //     const elemI = document.createElement("img");
  //     elemI.style = "position: absolute; left: 0px; z-index: 10;";
  //     elemI.setAttribute("src", lfdFile.videoCapture.dataUri);
  //     const el = ref.current;
  //     while (el.firstChild) {
  //       el.removeChild(el.lastChild);
  //     }

  //     setTimeout(() => {
  //       handleContinueButtonDisabled(false);
  //       el.appendChild(elemI);
  //     }, 100);
  //   }
  // }, [lfdFile.videoCapture]);

  const validateDroppedFile = (w, h) => {
    const expectedPixelsL = DATA_PRODUCTS.data[productIndex].pixels.lPixels;
    const expectedPixelsP = DATA_PRODUCTS.data[productIndex].pixels.pPixels;

    const expectedSizeL =
      DATA_PRODUCTS.data[productIndex].acceptedSizeText.lSizes;
    const expectedSizeP =
      DATA_PRODUCTS.data[productIndex].acceptedSizeText.pSizes;
    let expectedPixels;

    droppedFileType === "landscape"
      ? (expectedPixels = expectedPixelsL)
      : (expectedPixels = expectedPixelsP);

    let acceptedSizes;

    droppedFileType === "landscape"
      ? (acceptedSizes = expectedSizeL)
      : (acceptedSizes = expectedSizeP);

    const receivedPixels = w * h;

    const exists = Object.values(expectedPixels).includes(receivedPixels);

    if (exists) {
      console.log("right size");
      handleWarningMessageText("", false);
      return true;
    } else {
      handleWarningMessageText(
        `Dropped file is wrong size.\nRequired dimensions: ${acceptedSizes}`,
        true
      );
      console.log("wrong size");
      setFiles([]);
      // handleDropzoneChanges("payload", null);
      return false;
    }
  };

  const {
    acceptedFiles,
    fileRejections,
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject
  } = useDropzone({
    maxFiles: 1,
    noClick: false,
    multiple: false,
    accept: acceptedFileTypeString,

    onDropRejected: rejectedFiles => {
      console.log("rejected");
      handleWarningMessageText("wrong file type dropped.", true);
    },

    // accepted files are ones that are the correct file type.  File size is checked later
    onDropAccepted: acceptedFiles => {
      // clear out any populated videos

      setFiles(
        acceptedFiles.map(myfile =>
          Object.assign(myfile, {
            preview: URL.createObjectURL(myfile)
          })
        )
      );

      const newFile = acceptedFiles[0];
      const nameArray = newFile.name.split(".");
      const ext = nameArray[nameArray.length - 1];

      if (ext === "mp4") {
        setMediaType("video");
      } else {
        setMediaType("image");
      }

      if (ext !== "mp4") {
        console.log("not mp4 and acceptFiles = ", acceptedFiles);
        // accepted files has name, type, preview blob
        console.log("not mp4 and files = ", files);
        // files is still zero
        const i = new Image();
        i.onload = () => {
          console.log("i loaded");
          let reader = new FileReader();
          reader.readAsDataURL(newFile);
          reader.onload = () => {
            console.log("reader loaded");

            const droppedFileIsCorrectSize = validateDroppedFile(
              i.width,
              i.height
            );
            if (droppedFileIsCorrectSize) {
              console.log("image and correct");

              handleDropzoneChanges("name", newFile.name);
              handleDropzoneChanges("payload", newFile);
              handleDropzoneChanges("width", i.width);
              handleDropzoneChanges("height", i.height);
              handleDropzoneChanges("type", newFile.type);
              handleDropzoneChanges("size", newFile.size);
            }
          };
        };

        i.src = newFile.preview;
      } else {
        // need to interrogate video for its secrets
        const video = document.createElement("video");
        video.addEventListener("canplay", event => {
          const droppedFileIsCorrectSize = validateDroppedFile(
            video.videoWidth,
            video.videoHeight
          );
          if (droppedFileIsCorrectSize) {
            handleDropzoneChanges("payload", newFile);
            handleDropzoneChanges("width", video.videoWidth);
            handleDropzoneChanges("height", video.videoHeight);
            handleDropzoneChanges("type", newFile.type);
            handleDropzoneChanges("size", newFile.size);
            handleDropzoneChanges("name", newFile.name);
          }
        });
        video.src = URL.createObjectURL(newFile);
      }
    }
  });

  const style = useMemo(
    () => ({
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {})
    }),
    [isDragAccept, isDragReject]
  );

  return (
    <div
      className="dropzoneImageGrandParent"
      onMouseEnter={() => setShowHint(true)}
      onMouseLeave={() => setShowHint(false)}
    >
      {showHint ? (
        <div className="dropzoneHint">{acceptedFileTypeMessageString}</div>
      ) : null}
      <div {...getRootProps({ style })} className="dropZone newBaseStyle">
        <div className="droppedImageHolder">
          {/* old */}
          {/* {Object.keys(lfdFile).length === 0 ? ( */}

          {/* NEW - Show background if no preview files */}
          {previewFiles.length === 0 ? (
            <div
              style={dzBackgroundImage}
              className={`dzBackgroundImage ${
                shakeDropzoneBGImage ? "shakeIt" : ""
              }`}
            ></div>
          ) : null}
          {/* NEW - Unified preview rendering (the old version did was the below div but had nothing inside it) */}
          <div ref={ref} className="dropzoneImageParent">
            {externalFile &&
            externalFile.type &&
            externalFile.type.includes("video")
              ? videoPreview
              : imagePreview}
          </div>
        </div>

        <input {...getInputProps()} />
      </div>
    </div>
  );
}
